import { useQuery } from '@tanstack/react-query';
import { apiUserData, apiUserMyProfile, getAccessToken } from 'common/api/srm-api';
export const useUserReadCurrentQuery = () => {
    return useQuery({
        queryKey: ['userreadcurrent'],
        queryFn: apiUserData,
        enabled: false,
    });
};
export const useUserMyProfileQuery = () => {
    var _a;
    // console.log('useUserMyProfileQuery')
    const accessToken = (_a = getAccessToken()) !== null && _a !== void 0 ? _a : '';
    return useQuery({
        queryKey: ['usermyprofile', accessToken],
        queryFn: apiUserMyProfile,
        enabled: true,
    });
};
